import {Component, OnInit} from '@angular/core';
import {AngularComponentsModule} from '@common/angular-components.module';
import {BehaviorSubject, catchError, of, take} from 'rxjs';
import {CoreService} from '@common/_services/core.service';
import {ConfigService} from '@common/_services/config.service';
import {ActivatedRoute, Router} from '@angular/router';
import {WebLoginRequest} from '../../../services/authentication/model/webLoginRequest';
import {environment} from '../../environments/environment';
import {FormBuilder, UntypedFormGroup} from '@angular/forms';
import {LoginRequestDto} from '../../../services/authentication/model/loginRequestDto';
import {AuthenticationService} from '@common/_services/authentication.service';
import {WebAccessModel} from '../../../services/authentication/model/webAccessModel';
import {HttpErrorResponse} from '@angular/common/http';

@Component({
    selector: 'ovn-login',
    standalone: true,
    imports: [
        AngularComponentsModule
    ],
    templateUrl: './login.component.html',
    styleUrl: './login.component.scss'
})

export class LoginComponent implements OnInit {
    public loginForm: UntypedFormGroup;
    public userEmail: string;
    public hidePass: boolean = true;
    public loading$ = new BehaviorSubject<boolean>(true);
    public id: string = environment.standaloneData.id;

    constructor(
        private formBuilder: FormBuilder,
        private configService: ConfigService,
        private coreService: CoreService,
        private authenticationService: AuthenticationService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {

    }

    ngOnInit(): void {
        if (this.id) {
            this.loading$.next(false);
            this.loginForm = this.formBuilder.group({
                login: environment.production ? '' : 'simple-user@gmail.com',
                password: environment.production ? '' : '123456'
            });
        } else {
            this.activatedRoute.params.subscribe(routeParams => {
                if (routeParams && routeParams['token'] && routeParams['id']) {
                    this.requestToken(routeParams['id'], routeParams['token']);
                } else {
                    this.coreService.navigateToLogin(true);
                }
            });
        }
    }

    submitForm() {
        if (this.loginForm.invalid) {
            return;
        }

        const formData = this.loginForm.getRawValue();
        this.userEmail = formData && formData.login ? formData.login : '';

        const request: LoginRequestDto = {
            login: formData.login,
            password: formData.password
        };

        this.loading$.next(true);
        this.authenticationService.loginRequest(this.id, request).pipe(
            take(1),
            catchError(() => {
                this.loading$.next(false);
                return of();
            })
        ).subscribe((response: WebAccessModel) => {
            this.requestToken(this.id, response.token!);
        });
    }

    requestToken(brokerId: string, token: string): void {
        const request: WebLoginRequest = {
            deviceId: this.configService.deviceAndBrowserUuid.randomUUID,
            clientId: this.configService.authCredentials.clientId,
            brokerId
        };

        this.loading$.next(true);
        this.coreService.getToken(token, request).pipe(
            take(1),
            catchError((error: HttpErrorResponse) => {
                this.loading$.next(false);
                this.coreService.navigateToLogin(error.error?.message !== 'access_denied');
                return of();
            })
        ).subscribe(() => {
            this.loading$.next(false);
            this.router.navigate([`cabinet/${brokerId}/shipments/new`]).then();
        });
    }

    protected readonly environment = environment;
}
